(() => {
  const initialize = () => {
    document.querySelectorAll('[data-tenda-wallpaper-menu]').forEach(menu => {
      if (menu.dataset.tendaWallpaperReady) return;
      menu.dataset.tendaWallpaperReady = 'true';
      const summary = menu.querySelector(':scope > summary');
      const hubUrl = summary.getAttribute('data-link');
      summary.removeAttribute('data-link');
      menu.addEventListener('click', event => {
        if (event.detail <= 0 || menu.trigger !== 'hover' || !summary.contains(event.target)) return;
        if (!hubUrl) return;
        event.preventDefault();
        event.stopPropagation();
        window.location.href = hubUrl;
      }, true);
      const groups = [...menu.querySelectorAll('.tenda-wallpaper-group')];
      groups.forEach(group => group.addEventListener('toggle', () => {
        if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
      }));
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
